export default __webpack_public_path__ + "static/media/cover_hatemail-front--webres.730902cf.jpeg";